<template>
  <div class="homeBox pointer">
    <AochenHead
      :allGroupList="allGroupList"
      :gonggeshow="gonggeshow"
      @onGroup="onGroup"
      @refresh="refresh"
      @changeGonggeshow="SET_GONGGESHOW($event)"
    ></AochenHead>
    <AochenContent
      :instanceList="instanceList"
      :gonggeshow="gonggeshow"
      v-if="contentShow"
      @openCloudPhone="openCloudPhone"
    ></AochenContent>
    <AochenFooter></AochenFooter>
    <van-popup class="webImageImgPopup pcPopup" v-model="reminder_show">
      <div class="remi_img">
        <img
          class="webImageImg"
          v-if="reminder.imageUrl"
          :src="reminder.imageUrl"
          alt=""
          @click="remintz"
        />
        <div v-else class="remi_bt">
          <div class="remi_btP1">{{ reminder.title }}</div>
          <div class="remi_btP2" style="white-space: pre-wrap">
            {{ reminder.content }}
          </div>
        </div>
      </div>
      <div class="remi_guanbi" @click="reminder_show = false">
        <img src="../../assets/icons/guanbi.png" alt="" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import AochenFooter from "@/components/AochenFooter";
import AochenHead from "@/components/homePage/AochenHead.vue";
import AochenContent from "@/components/homePage/AochenContent.vue";

import { instancelist, groupList, activityreminder } from "@/api/index.js";
import { Toast } from "vant";
import { mapState, mapMutations } from "vuex";

export default {
  name: "Home",
  components: {
    // 底部
    AochenFooter,
    // 头部
    AochenHead,
    AochenContent,
  },
  data() {
    return {
      instanceList: [],
      allGroupList: [],
      contentShow: false,
      reminder: {},
      reminder_show: false,
      channelCodeOptions: [
        {
          label: "百度",
          value: "baidu",
          type: 0,
        },
        {
          label: "智能云",
          value: "intelligent",
          type: 1,
        },
        {
          label: "火山",
          value: "huoshan",
          type: 2,
        },
        {
          label: "华为",
          value: "huawei",
          type: 3,
        },
      ],
    };
  },
  mounted() {
    this.getInstancelist();
    // 事件总线订阅
    this.$bus.$on("instanceOperate", (data) => {
      this.getInstancelist();
    });
    if (this.$route.query.code) {
      this.SET_CHANNELCODE(atob(this.$route.query.code));
    }
  },
  beforeDestroy() {
    // 给总线上的hello事件解绑
    this.$bus.$off("instanceOperate");
  },

  computed: {
    //数组写法
    ...mapState("common", ["recordLong", "globalAllGroupList"]),
    ...mapState("perpetual", ["groupId", "gonggeshow"]),
    ...mapState("persistence", ["globalInstanceList"]),
    getChannelCode: {
      get() {
        return function (status) {
          let item = this.channelCodeOptions.find(
            (item) => item.value === status
          );
          if (item) {
            return item.type;
          }
        };
      },
    },
  },
  methods: {
    ...mapMutations("common", ["SET_RECORDLONG", "SET_GLOBALALLGROUPLIST"]),
    ...mapMutations("perpetual", ["SET_GROUPID", "SET_CHANNELCODE", "SET_GONGGESHOW"]),
    ...mapMutations("persistence", ["SET_GLOBALINSTANCELIST"]),
    getInstancelist() {
      if (this.groupId == -1) {
        instancelist().then((res) => {
          this.getActivityreminder();
          this.contentShow = true;
          if (res.code == 200) {
            this.instanceList = res.data;
            groupList().then((res) => {
              if (res.code == 200) {
                this.allGroupList = res.data;
                this.allGroupList.unshift({
                  id: -1,
                  groupName: "所有分组",
                  instanceList: this.instanceList,
                });
                this.SET_GLOBALALLGROUPLIST(this.allGroupList);
              }
            });
          }
        });
      } else {
        groupList().then((res) => {
          this.getActivityreminder();
          this.contentShow = true;
          if (res.code == 200) {
            this.allGroupList = res.data;
            let item = this.allGroupList.find(
              (item) => item.id == this.groupId
            );
            if (item) {
              this.instanceList = item.instanceList;
              instancelist().then((res) => {
                if (res.code == 200) {
                  this.allGroupList.unshift({
                    id: -1,
                    groupName: "所有分组",
                    instanceList: res.data,
                  });
                  this.SET_GLOBALALLGROUPLIST(this.allGroupList);
                }
              });
            } else {
              this.SET_GROUPID(-1);
              this.getInstancelist();
            }
          }
        });
      }
    },
    onGroup(id) {
      let item = this.allGroupList.find((item) => item.id == id);
      if (item) {
        this.instanceList = item.instanceList;
      }
    },
    refresh() {
      this.getInstancelist();
    },
    openCloudPhone(em) {
      this.$router.push({
        path: "/cloudPhone",
        query: {
          instanceCode: em.instanceCode,
          type: this.getChannelCode(em.channelCode),
        },
      });
    },
    // 获取活动提示
    getActivityreminder() {
      activityreminder().then((res) => {
        if (res.code == 200) {
          this.reminder = res.data;
          this.reminder_show = res.data.show;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.homeBox {
  height: 100%;
  background: linear-gradient(180deg, #e1e1fe 0%, #f5f7fb 100%);
}
.webImageImgPopup {
  width: 80%;
  background: none;
  overflow: hidden;
  .remi_img {
    margin: 16px auto 16px auto;
    .webImageImg {
      width: 100%;
    }
    .remi_bt {
      background: #fff;
      padding: 16px;
      border-radius: 10px;
      .remi_btP1 {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
      }
      .remi_btP2::-webkit-scrollbar {
        width: 0; /* 宽度设为0 */
        height: 0; /* 高度设为0 */
      }
      .remi_btP2 {
        font-size: 14px;
        overflow: auto;
        max-height: 400px;
      }
    }
    img {
      border-radius: 10px 10px 10px 10px;
    }
    overflow: hidden;
  }
  .remi_guanbi {
    img {
      width: 28px;
      height: 28px;
    }
  }
}
</style>